import {
  Box,
  MenuItem,
  MenuList,
  Paper,
  TextField,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchTwoTone from '@material-ui/icons/SearchTwoTone';
import React, { useEffect, useState } from "react";
import getToken from '../../getters/getToken';
import useAlerts from '../../hooks/useAlerts';
import apiRequest from '../../requests/apiRequest';
import { Method } from '../../requests/types';

const SearchField = ({ onEmitProduct, use_products }) => {
  const [inputValue, setInputValue] = useState('');
  const [products, setProducts] = useState([]);
  const token = getToken();
  const alerts = useAlerts();
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const idProducts = use_products.map(element => element.id)

  useEffect(() => {
    if (inputValue) {
      setIsLoadingRequest(true);
      
      apiRequest({
        url: '/product/search',
        method: Method.POST,
        data: { search: inputValue, with_zero_stocks: true, type: 'single', },
        auth: token,
      })
        .then((response: any) => {
          response = response.filter(element => {
            return !idProducts.includes(element.id)
          })          
          
          setProducts(response);
        })
        .catch((error) => {
            if (error.status === "ERROR") {
                alerts({
                    variant: 'error',
                    message: `${error.errors[0].message}`,
                    autoHideDuration: 5000,
                });
            }
        })
        .finally(() => setIsLoadingRequest(false));
    } else {
      setProducts([]);
    }
  }, [inputValue])

  const clickMenuItem = (product: any) => {
    product.count = 1;
    onEmitProduct(product);
    setInputValue('');
  }

  return (
    <div style={{ position: 'relative' }}>
      <TextField
        label='Введите название, артикул или ID товара'
        variant='outlined'
        value={inputValue}
        onChange={(event) => {setInputValue(event.target.value)}}
        InputProps={{ startAdornment: <SearchTwoTone /> }}
        size={'small'}
        fullWidth
      />
      <Paper
        style={{
          position: 'absolute',
          top: '37px',
          left: '0',
          right: '110px',
          zIndex: '10',
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        {isLoadingRequest &&
          <Box sx={{p: 2}}>
            <CircularProgress color='inherit' size={40} />
          </Box>          
        }
        {!isLoadingRequest && products.length > 0 &&
          <MenuList>
            {products.map((product, idx) => (
              <MenuItem
                key={product.id}
                value={product.name}
                style={{
                  whiteSpace: 'break-spaces',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
                onClick={() => clickMenuItem(product)}
              >
                {product.name}
              </MenuItem>
            ))}
          </MenuList>
        }
        {!isLoadingRequest && products.length === 0 && inputValue.length > 0 &&
         <Box sx={{p: 2}}>
          Совпадений нет
         </Box>
        }
      </Paper>
    </div>
  )
}

export default SearchField